import React from "react";
import { Card, Button } from "@mui/material";
import { PictureAsPdf as PictureAsPdfIcon } from "@mui/icons-material";

import { isValidArray } from "utils/array";
import useFileUpload from "./useFileUpload";
import FileDropzone from "components/common/dropzone/Dropzone";

const FileUpload = (props) => {
  const {
    cancelFile,
    pdfFileNames,
    pdfPreviewUrl,
    uploadReportId,
    handleFileUpload,
  } = useFileUpload(props);

  return (
    <div
      style={{
        boxSizing: "border-box",
        width: "100%",
        position: "relative",
      }}
    >
      {uploadReportId && !isValidArray(pdfFileNames) && (
        <Card className="mb-2" style={{ padding: 10 }}>
          <h4>
            <a
              href={`/patient/report/${uploadReportId}`}
              target="_blank"
              rel="noreferrer"
              data-action="file-upload-view-report-link"
            >
              Click here
            </a>{" "}
            to see the report.
          </h4>
        </Card>
      )}
      {!isValidArray(pdfFileNames) && (
        <Card style={{ padding: 10 }}>
          <FileDropzone
            onDrop={handleFileUpload}
            multiple={!props.isInOfficeUpload}
            data-action="file-upload-dropzone"
            content={
              <span>
                <p>Drag and drop PDF file/s here</p>
                <p>or</p>
              </span>
            }
          />
        </Card>
      )}
      {isValidArray(pdfFileNames) && (
        <div>
          <Card className="uploadFileNameWrapper mb-3">
            <div className="d-flex justify-between">
              <h3 data-label="file-upload-selected-files-header">
                Selected Files
              </h3>
              <Button
                variant="outlined"
                color="secondary"
                onClick={cancelFile}
                data-action="file-upload-replace-file-button"
              >
                Replace file
              </Button>
            </div>
            {pdfFileNames.map((fileName) => (
              <p key={fileName} className="d-flex align-center mb-2">
                <PictureAsPdfIcon
                  style={{ color: "#949494" }}
                  data-label="file-upload-pdf-icon"
                />
                <span
                  className="ml-2"
                  style={{ fontSize: "16px" }}
                  data-label={`file-upload-file-name-${fileName}`}
                >
                  {fileName}
                </span>
              </p>
            ))}
          </Card>

          {pdfPreviewUrl && !props.isInOfficeUpload && (
            <embed
              src={pdfPreviewUrl}
              type="application/pdf"
              style={{
                width: "100%",
                height: "100vh",
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
